export default [
    {
        path: "/procuring-entities/list",
        name: "procuring-entities",
        meta: {title: "procuring-entities", authRequired: false},
        component: () => import("../views/procuring-entities/list"),
    },
]